import { getHotelRequestLimit } from '../getHotelRequestLimit';

const validateHotelSpecialRequests = (trip, specialBookingRequests, hotelChainAdvisorBySegment) => {
  const hotelItineraries = Object.values(trip?.hotelItineraries || {});
  if (!hotelItineraries.length) return {};

  const invalidSegments = {};

  hotelItineraries.forEach((hotelItinerary) => {
    const { tripSegmentId, maxCharsHotelSpecialRequest } = hotelItinerary;

    const value = specialBookingRequests?.[tripSegmentId] || '';
    const advisorId = hotelChainAdvisorBySegment?.[tripSegmentId]?.advisorId;

    const { isOverLimit, remaining } = getHotelRequestLimit({
      maxCharsHotelSpecialRequest,
      advisorId,
      value,
    });

    if (isOverLimit) {
      invalidSegments[tripSegmentId] =
        `Your request exceeds the allowed limit by ${Math.abs(remaining)} character${
          Math.abs(remaining) > 1 ? 's' : ''
        }. Try shortening the message or updating the Advisor ID.`;
    }
  });

  return invalidSegments;
};

export default validateHotelSpecialRequests;
